var Bloodhound =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(16);

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * typeahead.js
	 * https://github.com/twitter/typeahead.js
	 * Copyright 2013-2014 Twitter, Inc. and other contributors; Licensed MIT
	 */
	
	'use strict';
	
	var assign = __webpack_require__(3);
	
	var _ = {
	  isMsie: function isMsie() {
	    // from https://github.com/ded/bowser/blob/master/bowser.js
	    return (/(msie|trident)/i.test(navigator.userAgent) ? navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2] : false
	    );
	  },
	
	  isBlankString: function isBlankString(str) {
	    return !str || /^\s*$/.test(str);
	  },
	
	  // http://stackoverflow.com/a/6969486
	  escapeRegExChars: function escapeRegExChars(str) {
	    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
	  },
	
	  isString: function isString(obj) {
	    return typeof obj === 'string';
	  },
	
	  isNumber: function isNumber(obj) {
	    return typeof obj === 'number';
	  },
	
	  isArray: Array.isArray,
	
	  isFunction: function isFunction(obj) {
	    return typeof obj === 'function';
	  },
	
	  isObject: function isObject(obj) {
	    return typeof obj === 'object';
	  },
	
	  isUndefined: function isUndefined(obj) {
	    return typeof obj === 'undefined';
	  },
	
	  isElement: function isElement(obj) {
	    return !!(obj && obj.nodeType === 1);
	  },
	
	  isJQuery: function isJQuery(obj) {
	    return obj instanceof $;
	  },
	
	  toStr: function toStr(s) {
	    return _.isUndefined(s) || s === null ? '' : s + '';
	  },
	
	  bind: function bind(fn, context) {
	    return fn.bind(context);
	  },
	
	  each: function each(collection, cb) {
	    collection.forEach(cb);
	  },
	
	  map: function map(array, fn) {
	    return array.map(fn);
	  },
	
	  filter: function filter(array, fn) {
	    return array.filter(fn);
	  },
	
	  every: function every(obj, test) {
	    var result = true;
	
	    if (!obj) {
	      return result;
	    }
	
	    // $.each(obj, function(key, val) {
	    //   if (!(result = test.call(null, val, key, obj))) {
	    //     return false;
	    //   }
	    // });
	
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        var val = obj[key];
	        if (!(result = test.call(null, val, key, obj))) {
	          return false;
	        }
	      }
	    }
	
	    return !!result;
	  },
	
	  some: function some(obj, test) {
	    var result = false;
	
	    if (!obj) {
	      return result;
	    }
	
	    // $.each(obj, function(key, val) {
	    //   if (result = test.call(null, val, key, obj)) {
	    //     return false;
	    //   }
	    // });
	
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        var val = obj[key];
	        if (result = test.call(null, val, key, obj)) {
	          return false;
	        }
	      }
	    }
	
	    return !!result;
	  },
	
	  mixin: __webpack_require__(3),
	
	  identity: function identity(x) {
	    return x;
	  },
	
	  clone: function clone(obj) {
	    return assign({}, obj);
	  },
	
	  getIdGenerator: function getIdGenerator() {
	    var counter = 0;
	    return function () {
	      return counter++;
	    };
	  },
	
	  templatify: function templatify(obj) {
	    return _.isFunction(obj) ? obj : template;
	
	    function template() {
	      return String(obj);
	    }
	  },
	
	  defer: function defer(fn) {
	    setTimeout(fn, 0);
	  },
	
	  debounce: function debounce(func, wait, immediate) {
	    var timeout, result;
	
	    return function () {
	      var context = this,
	          args = arguments,
	          later,
	          callNow;
	
	      later = function () {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	        }
	      };
	
	      callNow = immediate && !timeout;
	
	      clearTimeout(timeout);
	      timeout = setTimeout(later, wait);
	
	      if (callNow) {
	        result = func.apply(context, args);
	      }
	
	      return result;
	    };
	  },
	
	  throttle: function throttle(func, wait) {
	    var context, args, timeout, result, previous, later;
	
	    previous = 0;
	    later = function () {
	      previous = new Date();
	      timeout = null;
	      result = func.apply(context, args);
	    };
	
	    return function () {
	      var now = new Date(),
	          remaining = wait - (now - previous);
	
	      context = this;
	      args = arguments;
	
	      if (remaining <= 0) {
	        clearTimeout(timeout);
	        timeout = null;
	        previous = now;
	        result = func.apply(context, args);
	      } else if (!timeout) {
	        timeout = setTimeout(later, remaining);
	      }
	
	      return result;
	    };
	  },
	
	  stringify: function stringify(val) {
	    return _.isString(val) ? val : JSON.stringify(val);
	  },
	
	  noop: function noop() {},
	
	  error: function error(msg) {
	    throw new Error(msg);
	  }
	};
	
	module.exports = _;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var require;var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(process, global, module) {/*!
	 * @overview es6-promise - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/jakearchibald/es6-promise/master/LICENSE
	 * @version   3.0.2
	 */
	
	(function() {
	    "use strict";
	    function lib$es6$promise$utils$$objectOrFunction(x) {
	      return typeof x === 'function' || (typeof x === 'object' && x !== null);
	    }
	
	    function lib$es6$promise$utils$$isFunction(x) {
	      return typeof x === 'function';
	    }
	
	    function lib$es6$promise$utils$$isMaybeThenable(x) {
	      return typeof x === 'object' && x !== null;
	    }
	
	    var lib$es6$promise$utils$$_isArray;
	    if (!Array.isArray) {
	      lib$es6$promise$utils$$_isArray = function (x) {
	        return Object.prototype.toString.call(x) === '[object Array]';
	      };
	    } else {
	      lib$es6$promise$utils$$_isArray = Array.isArray;
	    }
	
	    var lib$es6$promise$utils$$isArray = lib$es6$promise$utils$$_isArray;
	    var lib$es6$promise$asap$$len = 0;
	    var lib$es6$promise$asap$$toString = {}.toString;
	    var lib$es6$promise$asap$$vertxNext;
	    var lib$es6$promise$asap$$customSchedulerFn;
	
	    var lib$es6$promise$asap$$asap = function asap(callback, arg) {
	      lib$es6$promise$asap$$queue[lib$es6$promise$asap$$len] = callback;
	      lib$es6$promise$asap$$queue[lib$es6$promise$asap$$len + 1] = arg;
	      lib$es6$promise$asap$$len += 2;
	      if (lib$es6$promise$asap$$len === 2) {
	        // If len is 2, that means that we need to schedule an async flush.
	        // If additional callbacks are queued before the queue is flushed, they
	        // will be processed by this flush that we are scheduling.
	        if (lib$es6$promise$asap$$customSchedulerFn) {
	          lib$es6$promise$asap$$customSchedulerFn(lib$es6$promise$asap$$flush);
	        } else {
	          lib$es6$promise$asap$$scheduleFlush();
	        }
	      }
	    }
	
	    function lib$es6$promise$asap$$setScheduler(scheduleFn) {
	      lib$es6$promise$asap$$customSchedulerFn = scheduleFn;
	    }
	
	    function lib$es6$promise$asap$$setAsap(asapFn) {
	      lib$es6$promise$asap$$asap = asapFn;
	    }
	
	    var lib$es6$promise$asap$$browserWindow = (typeof window !== 'undefined') ? window : undefined;
	    var lib$es6$promise$asap$$browserGlobal = lib$es6$promise$asap$$browserWindow || {};
	    var lib$es6$promise$asap$$BrowserMutationObserver = lib$es6$promise$asap$$browserGlobal.MutationObserver || lib$es6$promise$asap$$browserGlobal.WebKitMutationObserver;
	    var lib$es6$promise$asap$$isNode = typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';
	
	    // test for web worker but not in IE10
	    var lib$es6$promise$asap$$isWorker = typeof Uint8ClampedArray !== 'undefined' &&
	      typeof importScripts !== 'undefined' &&
	      typeof MessageChannel !== 'undefined';
	
	    // node
	    function lib$es6$promise$asap$$useNextTick() {
	      // node version 0.10.x displays a deprecation warning when nextTick is used recursively
	      // see https://github.com/cujojs/when/issues/410 for details
	      return function() {
	        process.nextTick(lib$es6$promise$asap$$flush);
	      };
	    }
	
	    // vertx
	    function lib$es6$promise$asap$$useVertxTimer() {
	      return function() {
	        lib$es6$promise$asap$$vertxNext(lib$es6$promise$asap$$flush);
	      };
	    }
	
	    function lib$es6$promise$asap$$useMutationObserver() {
	      var iterations = 0;
	      var observer = new lib$es6$promise$asap$$BrowserMutationObserver(lib$es6$promise$asap$$flush);
	      var node = document.createTextNode('');
	      observer.observe(node, { characterData: true });
	
	      return function() {
	        node.data = (iterations = ++iterations % 2);
	      };
	    }
	
	    // web worker
	    function lib$es6$promise$asap$$useMessageChannel() {
	      var channel = new MessageChannel();
	      channel.port1.onmessage = lib$es6$promise$asap$$flush;
	      return function () {
	        channel.port2.postMessage(0);
	      };
	    }
	
	    function lib$es6$promise$asap$$useSetTimeout() {
	      return function() {
	        setTimeout(lib$es6$promise$asap$$flush, 1);
	      };
	    }
	
	    var lib$es6$promise$asap$$queue = new Array(1000);
	    function lib$es6$promise$asap$$flush() {
	      for (var i = 0; i < lib$es6$promise$asap$$len; i+=2) {
	        var callback = lib$es6$promise$asap$$queue[i];
	        var arg = lib$es6$promise$asap$$queue[i+1];
	
	        callback(arg);
	
	        lib$es6$promise$asap$$queue[i] = undefined;
	        lib$es6$promise$asap$$queue[i+1] = undefined;
	      }
	
	      lib$es6$promise$asap$$len = 0;
	    }
	
	    function lib$es6$promise$asap$$attemptVertx() {
	      try {
	        var r = require;
	        var vertx = __webpack_require__(25);
	        lib$es6$promise$asap$$vertxNext = vertx.runOnLoop || vertx.runOnContext;
	        return lib$es6$promise$asap$$useVertxTimer();
	      } catch(e) {
	        return lib$es6$promise$asap$$useSetTimeout();
	      }
	    }
	
	    var lib$es6$promise$asap$$scheduleFlush;
	    // Decide what async method to use to triggering processing of queued callbacks:
	    if (lib$es6$promise$asap$$isNode) {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useNextTick();
	    } else if (lib$es6$promise$asap$$BrowserMutationObserver) {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useMutationObserver();
	    } else if (lib$es6$promise$asap$$isWorker) {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useMessageChannel();
	    } else if (lib$es6$promise$asap$$browserWindow === undefined && "function" === 'function') {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$attemptVertx();
	    } else {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useSetTimeout();
	    }
	
	    function lib$es6$promise$$internal$$noop() {}
	
	    var lib$es6$promise$$internal$$PENDING   = void 0;
	    var lib$es6$promise$$internal$$FULFILLED = 1;
	    var lib$es6$promise$$internal$$REJECTED  = 2;
	
	    var lib$es6$promise$$internal$$GET_THEN_ERROR = new lib$es6$promise$$internal$$ErrorObject();
	
	    function lib$es6$promise$$internal$$selfFulfillment() {
	      return new TypeError("You cannot resolve a promise with itself");
	    }
	
	    function lib$es6$promise$$internal$$cannotReturnOwn() {
	      return new TypeError('A promises callback cannot return that same promise.');
	    }
	
	    function lib$es6$promise$$internal$$getThen(promise) {
	      try {
	        return promise.then;
	      } catch(error) {
	        lib$es6$promise$$internal$$GET_THEN_ERROR.error = error;
	        return lib$es6$promise$$internal$$GET_THEN_ERROR;
	      }
	    }
	
	    function lib$es6$promise$$internal$$tryThen(then, value, fulfillmentHandler, rejectionHandler) {
	      try {
	        then.call(value, fulfillmentHandler, rejectionHandler);
	      } catch(e) {
	        return e;
	      }
	    }
	
	    function lib$es6$promise$$internal$$handleForeignThenable(promise, thenable, then) {
	       lib$es6$promise$asap$$asap(function(promise) {
	        var sealed = false;
	        var error = lib$es6$promise$$internal$$tryThen(then, thenable, function(value) {
	          if (sealed) { return; }
	          sealed = true;
	          if (thenable !== value) {
	            lib$es6$promise$$internal$$resolve(promise, value);
	          } else {
	            lib$es6$promise$$internal$$fulfill(promise, value);
	          }
	        }, function(reason) {
	          if (sealed) { return; }
	          sealed = true;
	
	          lib$es6$promise$$internal$$reject(promise, reason);
	        }, 'Settle: ' + (promise._label || ' unknown promise'));
	
	        if (!sealed && error) {
	          sealed = true;
	          lib$es6$promise$$internal$$reject(promise, error);
	        }
	      }, promise);
	    }
	
	    function lib$es6$promise$$internal$$handleOwnThenable(promise, thenable) {
	      if (thenable._state === lib$es6$promise$$internal$$FULFILLED) {
	        lib$es6$promise$$internal$$fulfill(promise, thenable._result);
	      } else if (thenable._state === lib$es6$promise$$internal$$REJECTED) {
	        lib$es6$promise$$internal$$reject(promise, thenable._result);
	      } else {
	        lib$es6$promise$$internal$$subscribe(thenable, undefined, function(value) {
	          lib$es6$promise$$internal$$resolve(promise, value);
	        }, function(reason) {
	          lib$es6$promise$$internal$$reject(promise, reason);
	        });
	      }
	    }
	
	    function lib$es6$promise$$internal$$handleMaybeThenable(promise, maybeThenable) {
	      if (maybeThenable.constructor === promise.constructor) {
	        lib$es6$promise$$internal$$handleOwnThenable(promise, maybeThenable);
	      } else {
	        var then = lib$es6$promise$$internal$$getThen(maybeThenable);
	
	        if (then === lib$es6$promise$$internal$$GET_THEN_ERROR) {
	          lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$GET_THEN_ERROR.error);
	        } else if (then === undefined) {
	          lib$es6$promise$$internal$$fulfill(promise, maybeThenable);
	        } else if (lib$es6$promise$utils$$isFunction(then)) {
	          lib$es6$promise$$internal$$handleForeignThenable(promise, maybeThenable, then);
	        } else {
	          lib$es6$promise$$internal$$fulfill(promise, maybeThenable);
	        }
	      }
	    }
	
	    function lib$es6$promise$$internal$$resolve(promise, value) {
	      if (promise === value) {
	        lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$selfFulfillment());
	      } else if (lib$es6$promise$utils$$objectOrFunction(value)) {
	        lib$es6$promise$$internal$$handleMaybeThenable(promise, value);
	      } else {
	        lib$es6$promise$$internal$$fulfill(promise, value);
	      }
	    }
	
	    function lib$es6$promise$$internal$$publishRejection(promise) {
	      if (promise._onerror) {
	        promise._onerror(promise._result);
	      }
	
	      lib$es6$promise$$internal$$publish(promise);
	    }
	
	    function lib$es6$promise$$internal$$fulfill(promise, value) {
	      if (promise._state !== lib$es6$promise$$internal$$PENDING) { return; }
	
	      promise._result = value;
	      promise._state = lib$es6$promise$$internal$$FULFILLED;
	
	      if (promise._subscribers.length !== 0) {
	        lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publish, promise);
	      }
	    }
	
	    function lib$es6$promise$$internal$$reject(promise, reason) {
	      if (promise._state !== lib$es6$promise$$internal$$PENDING) { return; }
	      promise._state = lib$es6$promise$$internal$$REJECTED;
	      promise._result = reason;
	
	      lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publishRejection, promise);
	    }
	
	    function lib$es6$promise$$internal$$subscribe(parent, child, onFulfillment, onRejection) {
	      var subscribers = parent._subscribers;
	      var length = subscribers.length;
	
	      parent._onerror = null;
	
	      subscribers[length] = child;
	      subscribers[length + lib$es6$promise$$internal$$FULFILLED] = onFulfillment;
	      subscribers[length + lib$es6$promise$$internal$$REJECTED]  = onRejection;
	
	      if (length === 0 && parent._state) {
	        lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publish, parent);
	      }
	    }
	
	    function lib$es6$promise$$internal$$publish(promise) {
	      var subscribers = promise._subscribers;
	      var settled = promise._state;
	
	      if (subscribers.length === 0) { return; }
	
	      var child, callback, detail = promise._result;
	
	      for (var i = 0; i < subscribers.length; i += 3) {
	        child = subscribers[i];
	        callback = subscribers[i + settled];
	
	        if (child) {
	          lib$es6$promise$$internal$$invokeCallback(settled, child, callback, detail);
	        } else {
	          callback(detail);
	        }
	      }
	
	      promise._subscribers.length = 0;
	    }
	
	    function lib$es6$promise$$internal$$ErrorObject() {
	      this.error = null;
	    }
	
	    var lib$es6$promise$$internal$$TRY_CATCH_ERROR = new lib$es6$promise$$internal$$ErrorObject();
	
	    function lib$es6$promise$$internal$$tryCatch(callback, detail) {
	      try {
	        return callback(detail);
	      } catch(e) {
	        lib$es6$promise$$internal$$TRY_CATCH_ERROR.error = e;
	        return lib$es6$promise$$internal$$TRY_CATCH_ERROR;
	      }
	    }
	
	    function lib$es6$promise$$internal$$invokeCallback(settled, promise, callback, detail) {
	      var hasCallback = lib$es6$promise$utils$$isFunction(callback),
	          value, error, succeeded, failed;
	
	      if (hasCallback) {
	        value = lib$es6$promise$$internal$$tryCatch(callback, detail);
	
	        if (value === lib$es6$promise$$internal$$TRY_CATCH_ERROR) {
	          failed = true;
	          error = value.error;
	          value = null;
	        } else {
	          succeeded = true;
	        }
	
	        if (promise === value) {
	          lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$cannotReturnOwn());
	          return;
	        }
	
	      } else {
	        value = detail;
	        succeeded = true;
	      }
	
	      if (promise._state !== lib$es6$promise$$internal$$PENDING) {
	        // noop
	      } else if (hasCallback && succeeded) {
	        lib$es6$promise$$internal$$resolve(promise, value);
	      } else if (failed) {
	        lib$es6$promise$$internal$$reject(promise, error);
	      } else if (settled === lib$es6$promise$$internal$$FULFILLED) {
	        lib$es6$promise$$internal$$fulfill(promise, value);
	      } else if (settled === lib$es6$promise$$internal$$REJECTED) {
	        lib$es6$promise$$internal$$reject(promise, value);
	      }
	    }
	
	    function lib$es6$promise$$internal$$initializePromise(promise, resolver) {
	      try {
	        resolver(function resolvePromise(value){
	          lib$es6$promise$$internal$$resolve(promise, value);
	        }, function rejectPromise(reason) {
	          lib$es6$promise$$internal$$reject(promise, reason);
	        });
	      } catch(e) {
	        lib$es6$promise$$internal$$reject(promise, e);
	      }
	    }
	
	    function lib$es6$promise$enumerator$$Enumerator(Constructor, input) {
	      var enumerator = this;
	
	      enumerator._instanceConstructor = Constructor;
	      enumerator.promise = new Constructor(lib$es6$promise$$internal$$noop);
	
	      if (enumerator._validateInput(input)) {
	        enumerator._input     = input;
	        enumerator.length     = input.length;
	        enumerator._remaining = input.length;
	
	        enumerator._init();
	
	        if (enumerator.length === 0) {
	          lib$es6$promise$$internal$$fulfill(enumerator.promise, enumerator._result);
	        } else {
	          enumerator.length = enumerator.length || 0;
	          enumerator._enumerate();
	          if (enumerator._remaining === 0) {
	            lib$es6$promise$$internal$$fulfill(enumerator.promise, enumerator._result);
	          }
	        }
	      } else {
	        lib$es6$promise$$internal$$reject(enumerator.promise, enumerator._validationError());
	      }
	    }
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._validateInput = function(input) {
	      return lib$es6$promise$utils$$isArray(input);
	    };
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._validationError = function() {
	      return new Error('Array Methods must be provided an Array');
	    };
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._init = function() {
	      this._result = new Array(this.length);
	    };
	
	    var lib$es6$promise$enumerator$$default = lib$es6$promise$enumerator$$Enumerator;
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._enumerate = function() {
	      var enumerator = this;
	
	      var length  = enumerator.length;
	      var promise = enumerator.promise;
	      var input   = enumerator._input;
	
	      for (var i = 0; promise._state === lib$es6$promise$$internal$$PENDING && i < length; i++) {
	        enumerator._eachEntry(input[i], i);
	      }
	    };
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._eachEntry = function(entry, i) {
	      var enumerator = this;
	      var c = enumerator._instanceConstructor;
	
	      if (lib$es6$promise$utils$$isMaybeThenable(entry)) {
	        if (entry.constructor === c && entry._state !== lib$es6$promise$$internal$$PENDING) {
	          entry._onerror = null;
	          enumerator._settledAt(entry._state, i, entry._result);
	        } else {
	          enumerator._willSettleAt(c.resolve(entry), i);
	        }
	      } else {
	        enumerator._remaining--;
	        enumerator._result[i] = entry;
	      }
	    };
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._settledAt = function(state, i, value) {
	      var enumerator = this;
	      var promise = enumerator.promise;
	
	      if (promise._state === lib$es6$promise$$internal$$PENDING) {
	        enumerator._remaining--;
	
	        if (state === lib$es6$promise$$internal$$REJECTED) {
	          lib$es6$promise$$internal$$reject(promise, value);
	        } else {
	          enumerator._result[i] = value;
	        }
	      }
	
	      if (enumerator._remaining === 0) {
	        lib$es6$promise$$internal$$fulfill(promise, enumerator._result);
	      }
	    };
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._willSettleAt = function(promise, i) {
	      var enumerator = this;
	
	      lib$es6$promise$$internal$$subscribe(promise, undefined, function(value) {
	        enumerator._settledAt(lib$es6$promise$$internal$$FULFILLED, i, value);
	      }, function(reason) {
	        enumerator._settledAt(lib$es6$promise$$internal$$REJECTED, i, reason);
	      });
	    };
	    function lib$es6$promise$promise$all$$all(entries) {
	      return new lib$es6$promise$enumerator$$default(this, entries).promise;
	    }
	    var lib$es6$promise$promise$all$$default = lib$es6$promise$promise$all$$all;
	    function lib$es6$promise$promise$race$$race(entries) {
	      /*jshint validthis:true */
	      var Constructor = this;
	
	      var promise = new Constructor(lib$es6$promise$$internal$$noop);
	
	      if (!lib$es6$promise$utils$$isArray(entries)) {
	        lib$es6$promise$$internal$$reject(promise, new TypeError('You must pass an array to race.'));
	        return promise;
	      }
	
	      var length = entries.length;
	
	      function onFulfillment(value) {
	        lib$es6$promise$$internal$$resolve(promise, value);
	      }
	
	      function onRejection(reason) {
	        lib$es6$promise$$internal$$reject(promise, reason);
	      }
	
	      for (var i = 0; promise._state === lib$es6$promise$$internal$$PENDING && i < length; i++) {
	        lib$es6$promise$$internal$$subscribe(Constructor.resolve(entries[i]), undefined, onFulfillment, onRejection);
	      }
	
	      return promise;
	    }
	    var lib$es6$promise$promise$race$$default = lib$es6$promise$promise$race$$race;
	    function lib$es6$promise$promise$resolve$$resolve(object) {
	      /*jshint validthis:true */
	      var Constructor = this;
	
	      if (object && typeof object === 'object' && object.constructor === Constructor) {
	        return object;
	      }
	
	      var promise = new Constructor(lib$es6$promise$$internal$$noop);
	      lib$es6$promise$$internal$$resolve(promise, object);
	      return promise;
	    }
	    var lib$es6$promise$promise$resolve$$default = lib$es6$promise$promise$resolve$$resolve;
	    function lib$es6$promise$promise$reject$$reject(reason) {
	      /*jshint validthis:true */
	      var Constructor = this;
	      var promise = new Constructor(lib$es6$promise$$internal$$noop);
	      lib$es6$promise$$internal$$reject(promise, reason);
	      return promise;
	    }
	    var lib$es6$promise$promise$reject$$default = lib$es6$promise$promise$reject$$reject;
	
	    var lib$es6$promise$promise$$counter = 0;
	
	    function lib$es6$promise$promise$$needsResolver() {
	      throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
	    }
	
	    function lib$es6$promise$promise$$needsNew() {
	      throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
	    }
	
	    var lib$es6$promise$promise$$default = lib$es6$promise$promise$$Promise;
	    /**
	      Promise objects represent the eventual result of an asynchronous operation. The
	      primary way of interacting with a promise is through its `then` method, which
	      registers callbacks to receive either a promise's eventual value or the reason
	      why the promise cannot be fulfilled.
	
	      Terminology
	      -----------
	
	      - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	      - `thenable` is an object or function that defines a `then` method.
	      - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	      - `exception` is a value that is thrown using the throw statement.
	      - `reason` is a value that indicates why a promise was rejected.
	      - `settled` the final resting state of a promise, fulfilled or rejected.
	
	      A promise can be in one of three states: pending, fulfilled, or rejected.
	
	      Promises that are fulfilled have a fulfillment value and are in the fulfilled
	      state.  Promises that are rejected have a rejection reason and are in the
	      rejected state.  A fulfillment value is never a thenable.
	
	      Promises can also be said to *resolve* a value.  If this value is also a
	      promise, then the original promise's settled state will match the value's
	      settled state.  So a promise that *resolves* a promise that rejects will
	      itself reject, and a promise that *resolves* a promise that fulfills will
	      itself fulfill.
	
	
	      Basic Usage:
	      ------------
	
	      ```js
	      var promise = new Promise(function(resolve, reject) {
	        // on success
	        resolve(value);
	
	        // on failure
	        reject(reason);
	      });
	
	      promise.then(function(value) {
	        // on fulfillment
	      }, function(reason) {
	        // on rejection
	      });
	      ```
	
	      Advanced Usage:
	      ---------------
	
	      Promises shine when abstracting away asynchronous interactions such as
	      `XMLHttpRequest`s.
	
	      ```js
	      function getJSON(url) {
	        return new Promise(function(resolve, reject){
	          var xhr = new XMLHttpRequest();
	
	          xhr.open('GET', url);
	          xhr.onreadystatechange = handler;
	          xhr.responseType = 'json';
	          xhr.setRequestHeader('Accept', 'application/json');
	          xhr.send();
	
	          function handler() {
	            if (this.readyState === this.DONE) {
	              if (this.status === 200) {
	                resolve(this.response);
	              } else {
	                reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	              }
	            }
	          };
	        });
	      }
	
	      getJSON('/posts.json').then(function(json) {
	        // on fulfillment
	      }, function(reason) {
	        // on rejection
	      });
	      ```
	
	      Unlike callbacks, promises are great composable primitives.
	
	      ```js
	      Promise.all([
	        getJSON('/posts'),
	        getJSON('/comments')
	      ]).then(function(values){
	        values[0] // => postsJSON
	        values[1] // => commentsJSON
	
	        return values;
	      });
	      ```
	
	      @class Promise
	      @param {function} resolver
	      Useful for tooling.
	      @constructor
	    */
	    function lib$es6$promise$promise$$Promise(resolver) {
	      this._id = lib$es6$promise$promise$$counter++;
	      this._state = undefined;
	      this._result = undefined;
	      this._subscribers = [];
	
	      if (lib$es6$promise$$internal$$noop !== resolver) {
	        if (!lib$es6$promise$utils$$isFunction(resolver)) {
	          lib$es6$promise$promise$$needsResolver();
	        }
	
	        if (!(this instanceof lib$es6$promise$promise$$Promise)) {
	          lib$es6$promise$promise$$needsNew();
	        }
	
	        lib$es6$promise$$internal$$initializePromise(this, resolver);
	      }
	    }
	
	    lib$es6$promise$promise$$Promise.all = lib$es6$promise$promise$all$$default;
	    lib$es6$promise$promise$$Promise.race = lib$es6$promise$promise$race$$default;
	    lib$es6$promise$promise$$Promise.resolve = lib$es6$promise$promise$resolve$$default;
	    lib$es6$promise$promise$$Promise.reject = lib$es6$promise$promise$reject$$default;
	    lib$es6$promise$promise$$Promise._setScheduler = lib$es6$promise$asap$$setScheduler;
	    lib$es6$promise$promise$$Promise._setAsap = lib$es6$promise$asap$$setAsap;
	    lib$es6$promise$promise$$Promise._asap = lib$es6$promise$asap$$asap;
	
	    lib$es6$promise$promise$$Promise.prototype = {
	      constructor: lib$es6$promise$promise$$Promise,
	
	    /**
	      The primary way of interacting with a promise is through its `then` method,
	      which registers callbacks to receive either a promise's eventual value or the
	      reason why the promise cannot be fulfilled.
	
	      ```js
	      findUser().then(function(user){
	        // user is available
	      }, function(reason){
	        // user is unavailable, and you are given the reason why
	      });
	      ```
	
	      Chaining
	      --------
	
	      The return value of `then` is itself a promise.  This second, 'downstream'
	      promise is resolved with the return value of the first promise's fulfillment
	      or rejection handler, or rejected if the handler throws an exception.
	
	      ```js
	      findUser().then(function (user) {
	        return user.name;
	      }, function (reason) {
	        return 'default name';
	      }).then(function (userName) {
	        // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	        // will be `'default name'`
	      });
	
	      findUser().then(function (user) {
	        throw new Error('Found user, but still unhappy');
	      }, function (reason) {
	        throw new Error('`findUser` rejected and we're unhappy');
	      }).then(function (value) {
	        // never reached
	      }, function (reason) {
	        // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	        // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
	      });
	      ```
	      If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
	
	      ```js
	      findUser().then(function (user) {
	        throw new PedagogicalException('Upstream error');
	      }).then(function (value) {
	        // never reached
	      }).then(function (value) {
	        // never reached
	      }, function (reason) {
	        // The `PedgagocialException` is propagated all the way down to here
	      });
	      ```
	
	      Assimilation
	      ------------
	
	      Sometimes the value you want to propagate to a downstream promise can only be
	      retrieved asynchronously. This can be achieved by returning a promise in the
	      fulfillment or rejection handler. The downstream promise will then be pending
	      until the returned promise is settled. This is called *assimilation*.
	
	      ```js
	      findUser().then(function (user) {
	        return findCommentsByAuthor(user);
	      }).then(function (comments) {
	        // The user's comments are now available
	      });
	      ```
	
	      If the assimliated promise rejects, then the downstream promise will also reject.
	
	      ```js
	      findUser().then(function (user) {
	        return findCommentsByAuthor(user);
	      }).then(function (comments) {
	        // If `findCommentsByAuthor` fulfills, we'll have the value here
	      }, function (reason) {
	        // If `findCommentsByAuthor` rejects, we'll have the reason here
	      });
	      ```
	
	      Simple Example
	      --------------
	
	      Synchronous Example
	
	      ```javascript
	      var result;
	
	      try {
	        result = findResult();
	        // success
	      } catch(reason) {
	        // failure
	      }
	      ```
	
	      Errback Example
	
	      ```js
	      findResult(function(result, err){
	        if (err) {
	          // failure
	        } else {
	          // success
	        }
	      });
	      ```
	
	      Promise Example;
	
	      ```javascript
	      findResult().then(function(result){
	        // success
	      }, function(reason){
	        // failure
	      });
	      ```
	
	      Advanced Example
	      --------------
	
	      Synchronous Example
	
	      ```javascript
	      var author, books;
	
	      try {
	        author = findAuthor();
	        books  = findBooksByAuthor(author);
	        // success
	      } catch(reason) {
	        // failure
	      }
	      ```
	
	      Errback Example
	
	      ```js
	
	      function foundBooks(books) {
	
	      }
	
	      function failure(reason) {
	
	      }
	
	      findAuthor(function(author, err){
	        if (err) {
	          failure(err);
	          // failure
	        } else {
	          try {
	            findBoooksByAuthor(author, function(books, err) {
	              if (err) {
	                failure(err);
	              } else {
	                try {
	                  foundBooks(books);
	                } catch(reason) {
	                  failure(reason);
	                }
	              }
	            });
	          } catch(error) {
	            failure(err);
	          }
	          // success
	        }
	      });
	      ```
	
	      Promise Example;
	
	      ```javascript
	      findAuthor().
	        then(findBooksByAuthor).
	        then(function(books){
	          // found books
	      }).catch(function(reason){
	        // something went wrong
	      });
	      ```
	
	      @method then
	      @param {Function} onFulfilled
	      @param {Function} onRejected
	      Useful for tooling.
	      @return {Promise}
	    */
	      then: function(onFulfillment, onRejection) {
	        var parent = this;
	        var state = parent._state;
	
	        if (state === lib$es6$promise$$internal$$FULFILLED && !onFulfillment || state === lib$es6$promise$$internal$$REJECTED && !onRejection) {
	          return this;
	        }
	
	        var child = new this.constructor(lib$es6$promise$$internal$$noop);
	        var result = parent._result;
	
	        if (state) {
	          var callback = arguments[state - 1];
	          lib$es6$promise$asap$$asap(function(){
	            lib$es6$promise$$internal$$invokeCallback(state, child, callback, result);
	          });
	        } else {
	          lib$es6$promise$$internal$$subscribe(parent, child, onFulfillment, onRejection);
	        }
	
	        return child;
	      },
	
	    /**
	      `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	      as the catch block of a try/catch statement.
	
	      ```js
	      function findAuthor(){
	        throw new Error('couldn't find that author');
	      }
	
	      // synchronous
	      try {
	        findAuthor();
	      } catch(reason) {
	        // something went wrong
	      }
	
	      // async with promises
	      findAuthor().catch(function(reason){
	        // something went wrong
	      });
	      ```
	
	      @method catch
	      @param {Function} onRejection
	      Useful for tooling.
	      @return {Promise}
	    */
	      'catch': function(onRejection) {
	        return this.then(null, onRejection);
	      }
	    };
	    function lib$es6$promise$polyfill$$polyfill() {
	      var local;
	
	      if (typeof global !== 'undefined') {
	          local = global;
	      } else if (typeof self !== 'undefined') {
	          local = self;
	      } else {
	          try {
	              local = Function('return this')();
	          } catch (e) {
	              throw new Error('polyfill failed because global object is unavailable in this environment');
	          }
	      }
	
	      var P = local.Promise;
	
	      if (P && Object.prototype.toString.call(P.resolve()) === '[object Promise]' && !P.cast) {
	        return;
	      }
	
	      local.Promise = lib$es6$promise$promise$$default;
	    }
	    var lib$es6$promise$polyfill$$default = lib$es6$promise$polyfill$$polyfill;
	
	    var lib$es6$promise$umd$$ES6Promise = {
	      'Promise': lib$es6$promise$promise$$default,
	      'polyfill': lib$es6$promise$polyfill$$default
	    };
	
	    /* global define:true module:true window: true */
	    if ("function" === 'function' && __webpack_require__(13)['amd']) {
	      !(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return lib$es6$promise$umd$$ES6Promise; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module !== 'undefined' && module['exports']) {
	      module['exports'] = lib$es6$promise$umd$$ES6Promise;
	    } else if (typeof this !== 'undefined') {
	      this['ES6Promise'] = lib$es6$promise$umd$$ES6Promise;
	    }
	
	    lib$es6$promise$polyfill$$default();
	}).call(this);
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), (function() { return this; }()), __webpack_require__(14)(module)))

/***/ },
/* 3 */
/***/ function(module, exports) {

	/* eslint-disable no-unused-vars */
	'use strict';
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var LruCache = __webpack_require__(17);
	var _ = __webpack_require__(1);
	
	var pendingRequestsCount = 0;
	var pendingRequests = {};
	var maxPendingRequests = 6;
	var sharedCache = new LruCache(10);
	
	function Transport(o) {
	  o = o || {};
	
	  this.cancelled = false;
	  this.lastReq = null;
	
	  this._send = o.transport;
	  this._get = o.limiter ? o.limiter(this._get) : this._get;
	
	  this._cache = o.cache === false ? new LruCache(0) : sharedCache;
	}
	
	Transport.setMaxPendingRequests = function setMaxPendingRequests(num) {
	  maxPendingRequests = num;
	};
	
	Transport.resetCache = function resetCache() {
	  sharedCache.reset();
	};
	
	_.mixin(Transport.prototype, {
	
	  _fingerprint: function _fingerprint(o) {
	    o = o || {};
	    return o.url + o.type + $.param(o.data || {});
	  },
	
	  _get: function _get(o, cb) {
	    var that = this,
	        fingerprint,
	        jqXhr;
	
	    fingerprint = this._fingerprint(o);
	
	    // #149: don't make a network request if there has been a cancellation
	    // or if the url doesn't match the last url Transport#get was invoked with
	    if (this.cancelled || fingerprint !== this.lastReq) {
	      return;
	    }
	
	    // a request is already in progress, piggyback off of it
	    if (jqXhr = pendingRequests[fingerprint]) {
	      // jqXhr.done(done).fail(fail);
	      jqXhr.then(done, fail);
	    }
	
	    // under the pending request threshold, so fire off a request
	    else if (pendingRequestsCount < maxPendingRequests) {
	        pendingRequestsCount++;
	        pendingRequests[fingerprint] =
	        // this._send(o).done(done).fail(fail).always(always);
	        this._send(o).then(function (resp) {
	          done(resp);
	          always();
	        }, function () {
	          fail();
	          always();
	        });
	      }
	
	      // at the pending request threshold, so hang out in the on deck circle
	      else {
	          this.onDeckRequestArgs = [].slice.call(arguments, 0);
	        }
	
	    function done(resp) {
	      cb(null, resp);
	      that._cache.set(fingerprint, resp);
	    }
	
	    function fail() {
	      cb(true);
	    }
	
	    function always() {
	      pendingRequestsCount--;
	      delete pendingRequests[fingerprint];
	
	      // ensures request is always made for the last query
	      if (that.onDeckRequestArgs) {
	        that._get.apply(that, that.onDeckRequestArgs);
	        that.onDeckRequestArgs = null;
	      }
	    }
	  },
	
	  get: function get(o, cb) {
	    var resp, fingerprint;
	
	    cb = cb || _.noop;
	    o = _.isString(o) ? { url: o } : o || {};
	
	    fingerprint = this._fingerprint(o);
	
	    this.cancelled = false;
	    this.lastReq = fingerprint;
	
	    // in-memory cache hit
	    if (resp = this._cache.get(fingerprint)) {
	      cb(null, resp);
	    }
	
	    // go to network
	    else {
	        this._get(o, cb);
	      }
	  },
	
	  cancel: function cancel() {
	    this.cancelled = true;
	  }
	});
	
	module.exports = Transport;

/***/ },
/* 5 */
/***/ function(module, exports) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	module.exports = Emitter;
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks[event] = this._callbacks[event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  var self = this;
	  this._callbacks = this._callbacks || {};
	
	  function on() {
	    self.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks[event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks[event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks[event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks[event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ },
/* 6 */
/***/ function(module, exports) {

	// shim for using process in browser
	
	var process = module.exports = {};
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = setTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    clearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        setTimeout(drainQueue, 0);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 7 */
/***/ function(module, exports) {

	
	/**
	 * Reduce `arr` with `fn`.
	 *
	 * @param {Array} arr
	 * @param {Function} fn
	 * @param {Mixed} initial
	 *
	 * TODO: combatible error handling?
	 */
	
	module.exports = function(arr, fn, initial){  
	  var idx = 0;
	  var len = arr.length;
	  var curr = arguments.length == 3
	    ? initial
	    : arr[idx++];
	
	  while (idx < len) {
	    curr = fn.call(null, curr, arr[idx], ++idx, arr);
	  }
	  
	  return curr;
	};

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var Storage = __webpack_require__(11);
	var cookie = __webpack_require__(9);
	
	var _storage_support = true;
	
	try {
	  window.localStorage.setItem('test', '42');
	  window.sessionStorage.setItem('test', '42');
	} catch(e) {
	  _storage_support = false;
	}
	
	if(_storage_support) {
	  window.localStorage.clear();
	  window.sessionStorage.clear();
	
	  module.exports = {
	    localStorage: window.localStorage,
	    sessionStorage: window.sessionStorage
	  };
	} else {
	  var lsCookie = cookie.read('localStorage');
	
	  var ls = new Storage(
	    lsCookie ? JSON.parse(lsCookie) : {}, // init
	    function(data) { // set
	      cookie.create('localStorage', JSON.stringify(data), 365);
	    },
	    function() { // clear
	      cookie.create('localStorage', '', 365);
	    }
	  );
	
	  var ss = new Storage();
	
	  module.exports = {
	    localStorage: ls,
	    sessionStorage: ss
	  };
	}


/***/ },
/* 9 */
/***/ function(module, exports) {

	function createCookie(name, value, days) {
	  var date, expires;
	
	  if(days) {
	    date = new Date();
	    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
	    expires = "; expires=" + date.toGMTString();
	  } else {
	    expires = "";
	  }
	  document.cookie = name + "=" + value + expires + "; path=/";
	}
	
	function readCookie(name) {
	  var nameEQ = name + "=",
	  ca = document.cookie.split(';'),
	  i, c;
	
	  for(i = 0; i < ca.length; i++) {
	    c = ca[i];
	    while(c.charAt(0) === ' ') {
	      c = c.substring(1, c.length);
	    }
	
	    if(c.indexOf(nameEQ) === 0) {
	      return c.substring(nameEQ.length, c.length);
	    }
	  }
	  return null;
	}
	
	module.exports = {
	  create: createCookie,
	  read: readCookie
	};


/***/ },
/* 10 */
/***/ function(module, exports) {

	module.exports = function(obj) {
	  var n = 0;
	  for(var k in obj) {
	    if(obj.hasOwnProperty(k)) {
	      n += 1;
	    }
	  }
	
	  return n;
	};


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var numKeys = __webpack_require__(10);
	
	function Storage(obj, set, clear) {
		this._obj = obj || {};
		this._set = set;
		this._clear = clear;
	
		this.length = 0;
	}
	
	var proto = Storage.prototype;
	
	// html5 storage api
	
	proto.setItem = function(k, v) {
		k = encodeURIComponent(k);
		this._obj[k] = v;
	
		this._updateLength();
		if(this._set) this._set(this._obj);
	};
	
	proto.getItem = function(k) {
		k = encodeURIComponent(k);
		return this._obj[k] === undefined ? null : this._obj[k];
	};
	
	proto.removeItem = function(k) {
		k = encodeURIComponent(k);
		delete this._obj[k];
	
		this._updateLength();
		if(this._set) this._set(this._obj);
	};
	
	proto.key = function(i) {
		var ctr = 0;
		for(var k in this._obj) {
			if(ctr === i) return decodeURIComponent(k);
			else ctr++;
		}
	
		return null;
	};
	
	proto.clear = function() {
		delete this['_obj'];
	
		if(this._clear) this._clear();
	};
	
	// private
	proto._updateLength = function() {
		this.length = numKeys(this._obj);
	};
	
	module.exports = Storage;


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var Emitter = __webpack_require__(5);
	var reduce = __webpack_require__(7);
	
	/**
	 * Root reference for iframes.
	 */
	
	var root;
	if (typeof window !== 'undefined') { // Browser window
	  root = window;
	} else if (typeof self !== 'undefined') { // Web Worker
	  root = self;
	} else { // Other environments
	  root = this;
	}
	
	/**
	 * Noop.
	 */
	
	function noop(){};
	
	/**
	 * Check if `obj` is a host object,
	 * we don't want to serialize these :)
	 *
	 * TODO: future proof, move to compoent land
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isHost(obj) {
	  var str = {}.toString.call(obj);
	
	  switch (str) {
	    case '[object File]':
	    case '[object Blob]':
	    case '[object FormData]':
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Determine XHR.
	 */
	
	request.getXHR = function () {
	  if (root.XMLHttpRequest
	      && (!root.location || 'file:' != root.location.protocol
	          || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  return false;
	};
	
	/**
	 * Removes leading and trailing whitespace, added to support IE.
	 *
	 * @param {String} s
	 * @return {String}
	 * @api private
	 */
	
	var trim = ''.trim
	  ? function(s) { return s.trim(); }
	  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };
	
	/**
	 * Check if `obj` is an object.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isObject(obj) {
	  return obj === Object(obj);
	}
	
	/**
	 * Serialize the given `obj`.
	 *
	 * @param {Object} obj
	 * @return {String}
	 * @api private
	 */
	
	function serialize(obj) {
	  if (!isObject(obj)) return obj;
	  var pairs = [];
	  for (var key in obj) {
	    if (null != obj[key]) {
	      pairs.push(encodeURIComponent(key)
	        + '=' + encodeURIComponent(obj[key]));
	    }
	  }
	  return pairs.join('&');
	}
	
	/**
	 * Expose serialization method.
	 */
	
	 request.serializeObject = serialize;
	
	 /**
	  * Parse the given x-www-form-urlencoded `str`.
	  *
	  * @param {String} str
	  * @return {Object}
	  * @api private
	  */
	
	function parseString(str) {
	  var obj = {};
	  var pairs = str.split('&');
	  var parts;
	  var pair;
	
	  for (var i = 0, len = pairs.length; i < len; ++i) {
	    pair = pairs[i];
	    parts = pair.split('=');
	    obj[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
	  }
	
	  return obj;
	}
	
	/**
	 * Expose parser.
	 */
	
	request.parseString = parseString;
	
	/**
	 * Default MIME type map.
	 *
	 *     superagent.types.xml = 'application/xml';
	 *
	 */
	
	request.types = {
	  html: 'text/html',
	  json: 'application/json',
	  xml: 'application/xml',
	  urlencoded: 'application/x-www-form-urlencoded',
	  'form': 'application/x-www-form-urlencoded',
	  'form-data': 'application/x-www-form-urlencoded'
	};
	
	/**
	 * Default serialization map.
	 *
	 *     superagent.serialize['application/xml'] = function(obj){
	 *       return 'generated xml here';
	 *     };
	 *
	 */
	
	 request.serialize = {
	   'application/x-www-form-urlencoded': serialize,
	   'application/json': JSON.stringify
	 };
	
	 /**
	  * Default parsers.
	  *
	  *     superagent.parse['application/xml'] = function(str){
	  *       return { object parsed from str };
	  *     };
	  *
	  */
	
	request.parse = {
	  'application/x-www-form-urlencoded': parseString,
	  'application/json': JSON.parse
	};
	
	/**
	 * Parse the given header `str` into
	 * an object containing the mapped fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function parseHeader(str) {
	  var lines = str.split(/\r?\n/);
	  var fields = {};
	  var index;
	  var line;
	  var field;
	  var val;
	
	  lines.pop(); // trailing CRLF
	
	  for (var i = 0, len = lines.length; i < len; ++i) {
	    line = lines[i];
	    index = line.indexOf(':');
	    field = line.slice(0, index).toLowerCase();
	    val = trim(line.slice(index + 1));
	    fields[field] = val;
	  }
	
	  return fields;
	}
	
	/**
	 * Return the mime type for the given `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	function type(str){
	  return str.split(/ *; */).shift();
	};
	
	/**
	 * Return header field parameters.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function params(str){
	  return reduce(str.split(/ *; */), function(obj, str){
	    var parts = str.split(/ *= */)
	      , key = parts.shift()
	      , val = parts.shift();
	
	    if (key && val) obj[key] = val;
	    return obj;
	  }, {});
	};
	
	/**
	 * Initialize a new `Response` with the given `xhr`.
	 *
	 *  - set flags (.ok, .error, etc)
	 *  - parse header
	 *
	 * Examples:
	 *
	 *  Aliasing `superagent` as `request` is nice:
	 *
	 *      request = superagent;
	 *
	 *  We can use the promise-like API, or pass callbacks:
	 *
	 *      request.get('/').end(function(res){});
	 *      request.get('/', function(res){});
	 *
	 *  Sending data can be chained:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' })
	 *        .end(function(res){});
	 *
	 *  Or passed to `.send()`:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' }, function(res){});
	 *
	 *  Or passed to `.post()`:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' })
	 *        .end(function(res){});
	 *
	 * Or further reduced to a single call for simple cases:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' }, function(res){});
	 *
	 * @param {XMLHTTPRequest} xhr
	 * @param {Object} options
	 * @api private
	 */
	
	function Response(req, options) {
	  options = options || {};
	  this.req = req;
	  this.xhr = this.req.xhr;
	  // responseText is accessible only if responseType is '' or 'text' and on older browsers
	  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
	     ? this.xhr.responseText
	     : null;
	  this.statusText = this.req.xhr.statusText;
	  this.setStatusProperties(this.xhr.status);
	  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
	  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
	  // getResponseHeader still works. so we get content-type even if getting
	  // other headers fails.
	  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
	  this.setHeaderProperties(this.header);
	  this.body = this.req.method != 'HEAD'
	    ? this.parseBody(this.text ? this.text : this.xhr.response)
	    : null;
	}
	
	/**
	 * Get case-insensitive `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	Response.prototype.get = function(field){
	  return this.header[field.toLowerCase()];
	};
	
	/**
	 * Set header related properties:
	 *
	 *   - `.type` the content type without params
	 *
	 * A response of "Content-Type: text/plain; charset=utf-8"
	 * will provide you with a `.type` of "text/plain".
	 *
	 * @param {Object} header
	 * @api private
	 */
	
	Response.prototype.setHeaderProperties = function(header){
	  // content-type
	  var ct = this.header['content-type'] || '';
	  this.type = type(ct);
	
	  // params
	  var obj = params(ct);
	  for (var key in obj) this[key] = obj[key];
	};
	
	/**
	 * Force given parser
	 * 
	 * Sets the body parser no matter type.
	 * 
	 * @param {Function}
	 * @api public
	 */
	
	Response.prototype.parse = function(fn){
	  this.parser = fn;
	  return this;
	};
	
	/**
	 * Parse the given body `str`.
	 *
	 * Used for auto-parsing of bodies. Parsers
	 * are defined on the `superagent.parse` object.
	 *
	 * @param {String} str
	 * @return {Mixed}
	 * @api private
	 */
	
	Response.prototype.parseBody = function(str){
	  var parse = this.parser || request.parse[this.type];
	  return parse && str && (str.length || str instanceof Object)
	    ? parse(str)
	    : null;
	};
	
	/**
	 * Set flags such as `.ok` based on `status`.
	 *
	 * For example a 2xx response will give you a `.ok` of __true__
	 * whereas 5xx will be __false__ and `.error` will be __true__. The
	 * `.clientError` and `.serverError` are also available to be more
	 * specific, and `.statusType` is the class of error ranging from 1..5
	 * sometimes useful for mapping respond colors etc.
	 *
	 * "sugar" properties are also defined for common cases. Currently providing:
	 *
	 *   - .noContent
	 *   - .badRequest
	 *   - .unauthorized
	 *   - .notAcceptable
	 *   - .notFound
	 *
	 * @param {Number} status
	 * @api private
	 */
	
	Response.prototype.setStatusProperties = function(status){
	  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	  if (status === 1223) {
	    status = 204;
	  }
	
	  var type = status / 100 | 0;
	
	  // status / class
	  this.status = this.statusCode = status;
	  this.statusType = type;
	
	  // basics
	  this.info = 1 == type;
	  this.ok = 2 == type;
	  this.clientError = 4 == type;
	  this.serverError = 5 == type;
	  this.error = (4 == type || 5 == type)
	    ? this.toError()
	    : false;
	
	  // sugar
	  this.accepted = 202 == status;
	  this.noContent = 204 == status;
	  this.badRequest = 400 == status;
	  this.unauthorized = 401 == status;
	  this.notAcceptable = 406 == status;
	  this.notFound = 404 == status;
	  this.forbidden = 403 == status;
	};
	
	/**
	 * Return an `Error` representative of this response.
	 *
	 * @return {Error}
	 * @api public
	 */
	
	Response.prototype.toError = function(){
	  var req = this.req;
	  var method = req.method;
	  var url = req.url;
	
	  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
	  var err = new Error(msg);
	  err.status = this.status;
	  err.method = method;
	  err.url = url;
	
	  return err;
	};
	
	/**
	 * Expose `Response`.
	 */
	
	request.Response = Response;
	
	/**
	 * Initialize a new `Request` with the given `method` and `url`.
	 *
	 * @param {String} method
	 * @param {String} url
	 * @api public
	 */
	
	function Request(method, url) {
	  var self = this;
	  Emitter.call(this);
	  this._query = this._query || [];
	  this.method = method;
	  this.url = url;
	  this.header = {};
	  this._header = {};
	  this.on('end', function(){
	    var err = null;
	    var res = null;
	
	    try {
	      res = new Response(self);
	    } catch(e) {
	      err = new Error('Parser is unable to parse the response');
	      err.parse = true;
	      err.original = e;
	      return self.callback(err);
	    }
	
	    self.emit('response', res);
	
	    if (err) {
	      return self.callback(err, res);
	    }
	
	    if (res.status >= 200 && res.status < 300) {
	      return self.callback(err, res);
	    }
	
	    var new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
	    new_err.original = err;
	    new_err.response = res;
	    new_err.status = res.status;
	
	    self.callback(new_err, res);
	  });
	}
	
	/**
	 * Mixin `Emitter`.
	 */
	
	Emitter(Request.prototype);
	
	/**
	 * Allow for extension
	 */
	
	Request.prototype.use = function(fn) {
	  fn(this);
	  return this;
	}
	
	/**
	 * Set timeout to `ms`.
	 *
	 * @param {Number} ms
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.timeout = function(ms){
	  this._timeout = ms;
	  return this;
	};
	
	/**
	 * Clear previous timeout.
	 *
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.clearTimeout = function(){
	  this._timeout = 0;
	  clearTimeout(this._timer);
	  return this;
	};
	
	/**
	 * Abort the request, and clear potential timeout.
	 *
	 * @return {Request}
	 * @api public
	 */
	
	Request.prototype.abort = function(){
	  if (this.aborted) return;
	  this.aborted = true;
	  this.xhr.abort();
	  this.clearTimeout();
	  this.emit('abort');
	  return this;
	};
	
	/**
	 * Set header `field` to `val`, or multiple fields with one object.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .set('Accept', 'application/json')
	 *        .set('X-API-Key', 'foobar')
	 *        .end(callback);
	 *
	 *      req.get('/')
	 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
	 *        .end(callback);
	 *
	 * @param {String|Object} field
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.set = function(field, val){
	  if (isObject(field)) {
	    for (var key in field) {
	      this.set(key, field[key]);
	    }
	    return this;
	  }
	  this._header[field.toLowerCase()] = val;
	  this.header[field] = val;
	  return this;
	};
	
	/**
	 * Remove header `field`.
	 *
	 * Example:
	 *
	 *      req.get('/')
	 *        .unset('User-Agent')
	 *        .end(callback);
	 *
	 * @param {String} field
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.unset = function(field){
	  delete this._header[field.toLowerCase()];
	  delete this.header[field];
	  return this;
	};
	
	/**
	 * Get case-insensitive header `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api private
	 */
	
	Request.prototype.getHeader = function(field){
	  return this._header[field.toLowerCase()];
	};
	
	/**
	 * Set Content-Type to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.xml = 'application/xml';
	 *
	 *      request.post('/')
	 *        .type('xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 *      request.post('/')
	 *        .type('application/xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 * @param {String} type
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.type = function(type){
	  this.set('Content-Type', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Accept to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.json = 'application/json';
	 *
	 *      request.get('/agent')
	 *        .accept('json')
	 *        .end(callback);
	 *
	 *      request.get('/agent')
	 *        .accept('application/json')
	 *        .end(callback);
	 *
	 * @param {String} accept
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.accept = function(type){
	  this.set('Accept', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Authorization field value with `user` and `pass`.
	 *
	 * @param {String} user
	 * @param {String} pass
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.auth = function(user, pass){
	  var str = btoa(user + ':' + pass);
	  this.set('Authorization', 'Basic ' + str);
	  return this;
	};
	
	/**
	* Add query-string `val`.
	*
	* Examples:
	*
	*   request.get('/shoes')
	*     .query('size=10')
	*     .query({ color: 'blue' })
	*
	* @param {Object|String} val
	* @return {Request} for chaining
	* @api public
	*/
	
	Request.prototype.query = function(val){
	  if ('string' != typeof val) val = serialize(val);
	  if (val) this._query.push(val);
	  return this;
	};
	
	/**
	 * Write the field `name` and `val` for "multipart/form-data"
	 * request bodies.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .field('foo', 'bar')
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} name
	 * @param {String|Blob|File} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.field = function(name, val){
	  if (!this._formData) this._formData = new root.FormData();
	  this._formData.append(name, val);
	  return this;
	};
	
	/**
	 * Queue the given `file` as an attachment to the specified `field`,
	 * with optional `filename`.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .attach(new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} field
	 * @param {Blob|File} file
	 * @param {String} filename
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.attach = function(field, file, filename){
	  if (!this._formData) this._formData = new root.FormData();
	  this._formData.append(field, file, filename);
	  return this;
	};
	
	/**
	 * Send `data`, defaulting the `.type()` to "json" when
	 * an object is given.
	 *
	 * Examples:
	 *
	 *       // querystring
	 *       request.get('/search')
	 *         .end(callback)
	 *
	 *       // multiple data "writes"
	 *       request.get('/search')
	 *         .send({ search: 'query' })
	 *         .send({ range: '1..5' })
	 *         .send({ order: 'desc' })
	 *         .end(callback)
	 *
	 *       // manual json
	 *       request.post('/user')
	 *         .type('json')
	 *         .send('{"name":"tj"})
	 *         .end(callback)
	 *
	 *       // auto json
	 *       request.post('/user')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // manual x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send('name=tj')
	 *         .end(callback)
	 *
	 *       // auto x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // defaults to x-www-form-urlencoded
	  *      request.post('/user')
	  *        .send('name=tobi')
	  *        .send('species=ferret')
	  *        .end(callback)
	 *
	 * @param {String|Object} data
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.send = function(data){
	  var obj = isObject(data);
	  var type = this.getHeader('Content-Type');
	
	  // merge
	  if (obj && isObject(this._data)) {
	    for (var key in data) {
	      this._data[key] = data[key];
	    }
	  } else if ('string' == typeof data) {
	    if (!type) this.type('form');
	    type = this.getHeader('Content-Type');
	    if ('application/x-www-form-urlencoded' == type) {
	      this._data = this._data
	        ? this._data + '&' + data
	        : data;
	    } else {
	      this._data = (this._data || '') + data;
	    }
	  } else {
	    this._data = data;
	  }
	
	  if (!obj || isHost(data)) return this;
	  if (!type) this.type('json');
	  return this;
	};
	
	/**
	 * Invoke the callback with `err` and `res`
	 * and handle arity check.
	 *
	 * @param {Error} err
	 * @param {Response} res
	 * @api private
	 */
	
	Request.prototype.callback = function(err, res){
	  var fn = this._callback;
	  this.clearTimeout();
	  fn(err, res);
	};
	
	/**
	 * Invoke callback with x-domain error.
	 *
	 * @api private
	 */
	
	Request.prototype.crossDomainError = function(){
	  var err = new Error('Origin is not allowed by Access-Control-Allow-Origin');
	  err.crossDomain = true;
	  this.callback(err);
	};
	
	/**
	 * Invoke callback with timeout error.
	 *
	 * @api private
	 */
	
	Request.prototype.timeoutError = function(){
	  var timeout = this._timeout;
	  var err = new Error('timeout of ' + timeout + 'ms exceeded');
	  err.timeout = timeout;
	  this.callback(err);
	};
	
	/**
	 * Enable transmission of cookies with x-domain requests.
	 *
	 * Note that for this to work the origin must not be
	 * using "Access-Control-Allow-Origin" with a wildcard,
	 * and also must set "Access-Control-Allow-Credentials"
	 * to "true".
	 *
	 * @api public
	 */
	
	Request.prototype.withCredentials = function(){
	  this._withCredentials = true;
	  return this;
	};
	
	/**
	 * Initiate request, invoking callback `fn(res)`
	 * with an instanceof `Response`.
	 *
	 * @param {Function} fn
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.end = function(fn){
	  var self = this;
	  var xhr = this.xhr = request.getXHR();
	  var query = this._query.join('&');
	  var timeout = this._timeout;
	  var data = this._formData || this._data;
	
	  // store callback
	  this._callback = fn || noop;
	
	  // state change
	  xhr.onreadystatechange = function(){
	    if (4 != xhr.readyState) return;
	
	    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
	    // result in the error "Could not complete the operation due to error c00c023f"
	    var status;
	    try { status = xhr.status } catch(e) { status = 0; }
	
	    if (0 == status) {
	      if (self.timedout) return self.timeoutError();
	      if (self.aborted) return;
	      return self.crossDomainError();
	    }
	    self.emit('end');
	  };
	
	  // progress
	  var handleProgress = function(e){
	    if (e.total > 0) {
	      e.percent = e.loaded / e.total * 100;
	    }
	    self.emit('progress', e);
	  };
	  if (this.hasListeners('progress')) {
	    xhr.onprogress = handleProgress;
	  }
	  try {
	    if (xhr.upload && this.hasListeners('progress')) {
	      xhr.upload.onprogress = handleProgress;
	    }
	  } catch(e) {
	    // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
	    // Reported here:
	    // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
	  }
	
	  // timeout
	  if (timeout && !this._timer) {
	    this._timer = setTimeout(function(){
	      self.timedout = true;
	      self.abort();
	    }, timeout);
	  }
	
	  // querystring
	  if (query) {
	    query = request.serializeObject(query);
	    this.url += ~this.url.indexOf('?')
	      ? '&' + query
	      : '?' + query;
	  }
	
	  // initiate request
	  xhr.open(this.method, this.url, true);
	
	  // CORS
	  if (this._withCredentials) xhr.withCredentials = true;
	
	  // body
	  if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !isHost(data)) {
	    // serialize stuff
	    var contentType = this.getHeader('Content-Type');
	    var serialize = request.serialize[contentType ? contentType.split(';')[0] : ''];
	    if (serialize) data = serialize(data);
	  }
	
	  // set header fields
	  for (var field in this.header) {
	    if (null == this.header[field]) continue;
	    xhr.setRequestHeader(field, this.header[field]);
	  }
	
	  // send stuff
	  this.emit('request', this);
	  xhr.send(data);
	  return this;
	};
	
	/**
	 * Faux promise support
	 *
	 * @param {Function} fulfill
	 * @param {Function} reject
	 * @return {Request}
	 */
	
	Request.prototype.then = function (fulfill, reject) {
	  return this.end(function(err, res) {
	    err ? reject(err) : fulfill(res);
	  });
	}
	
	/**
	 * Expose `Request`.
	 */
	
	request.Request = Request;
	
	/**
	 * Issue a request:
	 *
	 * Examples:
	 *
	 *    request('GET', '/users').end(callback)
	 *    request('/users').end(callback)
	 *    request('/users', callback)
	 *
	 * @param {String} method
	 * @param {String|Function} url or callback
	 * @return {Request}
	 * @api public
	 */
	
	function request(method, url) {
	  // callback
	  if ('function' == typeof url) {
	    return new Request('GET', method).end(url);
	  }
	
	  // url first
	  if (1 == arguments.length) {
	    return new Request('GET', method);
	  }
	
	  return new Request(method, url);
	}
	
	/**
	 * GET `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.get = function(url, data, fn){
	  var req = request('GET', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * HEAD `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.head = function(url, data, fn){
	  var req = request('HEAD', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * DELETE `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.del = function(url, fn){
	  var req = request('DELETE', url);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PATCH `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.patch = function(url, data, fn){
	  var req = request('PATCH', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * POST `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.post = function(url, data, fn){
	  var req = request('POST', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PUT `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.put = function(url, data, fn){
	  var req = request('PUT', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * Expose `request`.
	 */
	
	module.exports = request;


/***/ },
/* 13 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 14 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(2).Promise;
	var request = __webpack_require__(12);
	
	module.exports = function (o) {
	  return new Promise(function (resolve, reject) {
	    request.get(o.url).end(function (err, res) {
	      if (err) return reject(err);
	      resolve(res.body);
	    });
	  });
	};

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var Promise = __webpack_require__(2).Promise;
	var Remote = __webpack_require__(21);
	var Prefetch = __webpack_require__(20);
	var tokenizers = __webpack_require__(23);
	var oParser = __webpack_require__(18);
	var SearchIndex = __webpack_require__(22);
	var Transport = __webpack_require__(4);
	
	function Bloodhound(o) {
	  o = oParser(o);
	
	  this.sorter = o.sorter;
	  this.identify = o.identify;
	  this.sufficient = o.sufficient;
	
	  this.local = o.local;
	  this.remote = o.remote ? new Remote(o.remote) : null;
	  this.prefetch = o.prefetch ? new Prefetch(o.prefetch) : null;
	
	  // the backing data structure used for fast pattern matching
	  this.index = new SearchIndex({
	    identify: this.identify,
	    datumTokenizer: o.datumTokenizer,
	    queryTokenizer: o.queryTokenizer
	  });
	
	  // hold off on intialization if the intialize option was explicitly false
	  o.initialize !== false && this.initialize();
	}
	
	Bloodhound.tokenizers = tokenizers;
	
	_.mixin(Bloodhound.prototype, {
	
	  // ### super secret stuff used for integration with jquery plugin
	
	  __ttAdapter: function ttAdapter() {
	    var that = this;
	
	    return this.remote ? withAsync : withoutAsync;
	
	    function withAsync(query, sync, async) {
	      return that.search(query, sync, async);
	    }
	
	    function withoutAsync(query, sync) {
	      return that.search(query, sync);
	    }
	  },
	
	  _loadPrefetch: function loadPrefetch() {
	    var that = this,
	        promise,
	        serialized;
	
	    if (!this.prefetch) {
	      return new Promise(function (resolve, reject) {
	        resolve();
	      });
	    } else if (serialized = this.prefetch.fromCache()) {
	      this.index.bootstrap(serialized);
	      return new Promise(function (resolve, reject) {
	        resolve();
	      });
	    } else {
	      // this.prefetch.fromNetwork(done);
	      return new Promise(function (resolve, reject) {
	
	        // todo: promise
	        that.prefetch.fromNetwork(function (err, data) {
	          if (err) return reject(err);
	
	          try {
	            that.add(data);
	            that.prefetch.store(that.index.serialize());
	            resolve();
	          } catch (e) {
	            reject(e);
	          }
	        });
	      });
	    }
	  },
	
	  _initialize: function _initialize() {
	    var that = this,
	        deferred;
	
	    // in case this is a reinitialization, clear previous data
	    this.clear();
	
	    (this.initPromise = this._loadPrefetch()).then(addLocalToIndex); // local must be added to index after prefetch
	
	    return this.initPromise;
	
	    function addLocalToIndex() {
	      that.add(that.local);
	    }
	  },
	
	  // ### public
	
	  initialize: function initialize(force) {
	    return !this.initPromise || force ? this._initialize() : this.initPromise;
	  },
	
	  // TODO: before initialize what happens?
	  add: function add(data) {
	    this.index.add(data);
	    return this;
	  },
	
	  get: function get(ids) {
	    ids = _.isArray(ids) ? ids : [].slice.call(arguments);
	    return this.index.get(ids);
	  },
	
	  search: function search(query, sync, async) {
	    var that = this,
	        local;
	
	    local = this.sorter(this.index.search(query));
	
	    // return a copy to guarantee no changes within this scope
	    // as this array will get used when processing the remote results
	    sync(this.remote ? local.slice() : local);
	
	    if (this.remote && local.length < this.sufficient) {
	      this.remote.get(query, processRemote);
	    } else if (this.remote) {
	      // #149: prevents outdated rate-limited requests from being sent
	      this.remote.cancelLastRequest();
	    }
	
	    return this;
	
	    function processRemote(remote) {
	      var nonDuplicates = [];
	
	      // exclude duplicates
	      _.each(remote, function (r) {
	        !_.some(local, function (l) {
	          return that.identify(r) === that.identify(l);
	        }) && nonDuplicates.push(r);
	      });
	
	      async && async(nonDuplicates);
	    }
	  },
	
	  all: function all() {
	    return this.index.all();
	  },
	
	  clear: function clear() {
	    this.index.reset();
	    return this;
	  },
	
	  clearPrefetchCache: function clearPrefetchCache() {
	    this.prefetch && this.prefetch.clear();
	    return this;
	  },
	
	  clearRemoteCache: function clearRemoteCache() {
	    Transport.resetCache();
	    return this;
	  },
	
	  // DEPRECATED: will be removed in v1
	  ttAdapter: function ttAdapter() {
	    return this.__ttAdapter();
	  }
	});
	
	module.exports = Bloodhound;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * typeahead.js
	 * https://github.com/twitter/typeahead.js
	 * Copyright 2013-2014 Twitter, Inc. and other contributors; Licensed MIT
	 */
	
	// inspired by https://github.com/jharding/lru-cache
	
	'use strict';
	
	var _ = __webpack_require__(1);
	
	function LruCache(maxSize) {
	  this.maxSize = _.isNumber(maxSize) ? maxSize : 100;
	  this.reset();
	
	  // if max size is less than 0, provide a noop cache
	  if (this.maxSize <= 0) {
	    this.set = this.get = _.noop;
	  }
	}
	
	_.mixin(LruCache.prototype, {
	  set: function set(key, val) {
	    var tailItem = this.list.tail,
	        node;
	
	    // at capacity
	    if (this.size >= this.maxSize) {
	      this.list.remove(tailItem);
	      delete this.hash[tailItem.key];
	
	      this.size--;
	    }
	
	    // writing over existing key
	    if (node = this.hash[key]) {
	      node.val = val;
	      this.list.moveToFront(node);
	    }
	
	    // new key
	    else {
	        node = new Node(key, val);
	
	        this.list.add(node);
	        this.hash[key] = node;
	
	        this.size++;
	      }
	  },
	
	  get: function get(key) {
	    var node = this.hash[key];
	
	    if (node) {
	      this.list.moveToFront(node);
	      return node.val;
	    }
	  },
	
	  reset: function reset() {
	    this.size = 0;
	    this.hash = {};
	    this.list = new List();
	  }
	});
	
	function List() {
	  this.head = this.tail = null;
	}
	
	_.mixin(List.prototype, {
	  add: function add(node) {
	    if (this.head) {
	      node.next = this.head;
	      this.head.prev = node;
	    }
	
	    this.head = node;
	    this.tail = this.tail || node;
	  },
	
	  remove: function remove(node) {
	    node.prev ? node.prev.next = node.next : this.head = node.next;
	    node.next ? node.next.prev = node.prev : this.tail = node.prev;
	  },
	
	  moveToFront: function moveToFront(node) {
	    this.remove(node);
	    this.add(node);
	  }
	});
	
	function Node(key, val) {
	  this.key = key;
	  this.val = val;
	  this.prev = this.next = null;
	}
	
	module.exports = LruCache;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var ajax = __webpack_require__(15);
	var VERSION = __webpack_require__(24);
	
	module.exports = function (o) {
	  var defaults, sorter;
	
	  defaults = {
	    initialize: true,
	    identify: _.stringify,
	    datumTokenizer: null,
	    queryTokenizer: null,
	    sufficient: 5,
	    sorter: null,
	    local: [],
	    prefetch: null,
	    remote: null
	  };
	
	  o = _.mixin(defaults, o || {});
	
	  // throw error if required options are not set
	  !o.datumTokenizer && _.error('datumTokenizer is required');
	  !o.queryTokenizer && _.error('queryTokenizer is required');
	
	  sorter = o.sorter;
	  o.sorter = sorter ? function (x) {
	    return x.sort(sorter);
	  } : _.identity;
	
	  o.local = _.isFunction(o.local) ? o.local() : o.local;
	  o.prefetch = parsePrefetch(o.prefetch);
	  o.remote = parseRemote(o.remote);
	
	  return o;
	};
	
	function parsePrefetch(o) {
	  var defaults;
	
	  if (!o) {
	    return null;
	  }
	
	  defaults = {
	    url: null,
	    ttl: 24 * 60 * 60 * 1000, // 1 day
	    cache: true,
	    cacheKey: null,
	    thumbprint: '',
	    prepare: _.identity,
	    transform: _.identity,
	    transport: null
	  };
	
	  // support basic (url) and advanced configuration
	  o = _.isString(o) ? { url: o } : o;
	  o = _.mixin(defaults, o);
	
	  // throw error if required options are not set
	  !o.url && _.error('prefetch requires url to be set');
	
	  // DEPRECATED: filter will be dropped in v1
	  o.transform = o.filter || o.transform;
	
	  o.cacheKey = o.cacheKey || o.url;
	  o.thumbprint = VERSION + o.thumbprint;
	  o.transport = o.transport ? callbackToDeferred(o.transport) : ajax;
	
	  return o;
	}
	
	function parseRemote(o) {
	  var defaults;
	
	  if (!o) {
	    return;
	  }
	
	  defaults = {
	    url: null,
	    cache: true, // leave undocumented
	    prepare: null,
	    replace: null,
	    wildcard: null,
	    limiter: null,
	    rateLimitBy: 'debounce',
	    rateLimitWait: 300,
	    transform: _.identity,
	    transport: null
	  };
	
	  // support basic (url) and advanced configuration
	  o = _.isString(o) ? { url: o } : o;
	  o = _.mixin(defaults, o);
	
	  // throw error if required options are not set
	  !o.url && _.error('remote requires url to be set');
	
	  // DEPRECATED: filter will be dropped in v1
	  o.transform = o.filter || o.transform;
	
	  o.prepare = toRemotePrepare(o);
	  o.limiter = toLimiter(o);
	  o.transport = o.transport ? callbackToDeferred(o.transport) : ajax;
	
	  delete o.replace;
	  delete o.wildcard;
	  delete o.rateLimitBy;
	  delete o.rateLimitWait;
	
	  return o;
	}
	
	function toRemotePrepare(o) {
	  var prepare, replace, wildcard;
	
	  prepare = o.prepare;
	  replace = o.replace;
	  wildcard = o.wildcard;
	
	  if (prepare) {
	    return prepare;
	  }
	
	  if (replace) {
	    prepare = prepareByReplace;
	  } else if (o.wildcard) {
	    prepare = prepareByWildcard;
	  } else {
	    prepare = idenityPrepare;
	  }
	
	  return prepare;
	
	  function prepareByReplace(query, settings) {
	    settings.url = replace(settings.url, query);
	    return settings;
	  }
	
	  function prepareByWildcard(query, settings) {
	    settings.url = settings.url.replace(wildcard, encodeURIComponent(query));
	    return settings;
	  }
	
	  function idenityPrepare(query, settings) {
	    return settings;
	  }
	}
	
	function toLimiter(o) {
	  var limiter, method, wait;
	
	  limiter = o.limiter;
	  method = o.rateLimitBy;
	  wait = o.rateLimitWait;
	
	  if (!limiter) {
	    limiter = /^throttle$/i.test(method) ? throttle(wait) : debounce(wait);
	  }
	
	  return limiter;
	
	  function debounce(wait) {
	    return function (fn) {
	      return _.debounce(fn, wait);
	    };
	  }
	
	  function throttle(wait) {
	    return function (fn) {
	      return _.throttle(fn, wait);
	    };
	  }
	}
	
	function callbackToDeferred(fn) {
	  return function (o) {
	    // var deferred = $.Deferred();
	
	    // fn(o, onSuccess, onError);
	
	    // return deferred;
	
	    // function onSuccess(resp) {
	    //   // defer in case fn is synchronous, otherwise done
	    //   // and always handlers will be attached after the resolution
	    //   _.defer(function() { deferred.resolve(resp); });
	    // }
	
	    // function onError(err) {
	    //   // defer in case fn is synchronous, otherwise done
	    //   // and always handlers will be attached after the resolution
	    //   _.defer(function() { deferred.reject(err); });
	    // }
	  };
	}

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var storage2 = __webpack_require__(8);
	var _ = __webpack_require__(1);
	
	var LOCAL_STORAGE;
	
	try {
	  LOCAL_STORAGE = storage2.localStorage;
	
	  // while in private browsing mode, some browsers make
	  // localStorage available, but throw an error when used
	  LOCAL_STORAGE.setItem('~~~', '!');
	  LOCAL_STORAGE.removeItem('~~~');
	} catch (err) {
	  LOCAL_STORAGE = null;
	}
	
	// constructor
	// -----------
	
	function PersistentStorage(namespace, override) {
	  this.prefix = ['__', namespace, '__'].join('');
	  this.ttlKey = '__ttl__';
	  this.keyMatcher = new RegExp('^' + _.escapeRegExChars(this.prefix));
	
	  // for testing purpose
	  this.ls = override || LOCAL_STORAGE;
	
	  // if local storage isn't available, everything becomes a noop
	  !this.ls && this._noop();
	}
	
	// instance methods
	// ----------------
	
	_.mixin(PersistentStorage.prototype, {
	  // ### private
	
	  _prefix: function _prefix(key) {
	    return this.prefix + key;
	  },
	
	  _ttlKey: function _ttlKey(key) {
	    return this._prefix(key) + this.ttlKey;
	  },
	
	  _noop: function _noop() {
	    this.get = this.set = this.remove = this.clear = this.isExpired = _.noop;
	  },
	
	  _safeSet: function _safeSet(key, val) {
	    try {
	      this.ls.setItem(key, val);
	    } catch (err) {
	      // hit the localstorage limit so clean up and better luck next time
	      if (err.name === 'QuotaExceededError') {
	        this.clear();
	        this._noop();
	      }
	    }
	  },
	
	  // ### public
	
	  get: function get(key) {
	    if (this.isExpired(key)) {
	      this.remove(key);
	    }
	
	    return decode(this.ls.getItem(this._prefix(key)));
	  },
	
	  set: function set(key, val, ttl) {
	    if (_.isNumber(ttl)) {
	      this._safeSet(this._ttlKey(key), encode(now() + ttl));
	    } else {
	      this.ls.removeItem(this._ttlKey(key));
	    }
	
	    return this._safeSet(this._prefix(key), encode(val));
	  },
	
	  remove: function remove(key) {
	    this.ls.removeItem(this._ttlKey(key));
	    this.ls.removeItem(this._prefix(key));
	
	    return this;
	  },
	
	  clear: function clear() {
	    var i,
	        keys = gatherMatchingKeys(this.keyMatcher);
	
	    for (i = keys.length; i--;) {
	      this.remove(keys[i]);
	    }
	
	    return this;
	  },
	
	  isExpired: function isExpired(key) {
	    var ttl = decode(this.ls.getItem(this._ttlKey(key)));
	
	    return _.isNumber(ttl) && now() > ttl ? true : false;
	  }
	});
	
	// helper functions
	// ----------------
	
	function now() {
	  return new Date().getTime();
	}
	
	function encode(val) {
	  // convert undefined to null to avoid issues with JSON.parse
	  return JSON.stringify(_.isUndefined(val) ? null : val);
	}
	
	function decode(val) {
	  return JSON.parse(val);
	  // return $.parseJSON(val);
	}
	
	function gatherMatchingKeys(keyMatcher) {
	  var i,
	      key,
	      keys = [],
	      len = LOCAL_STORAGE.length;
	
	  for (i = 0; i < len; i++) {
	    if ((key = LOCAL_STORAGE.key(i)).match(keyMatcher)) {
	      keys.push(key.replace(keyMatcher, ''));
	    }
	  }
	
	  return keys;
	}
	
	module.exports = PersistentStorage;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var PersistentStorage = __webpack_require__(19);
	var _ = __webpack_require__(1);
	
	var keys = { data: 'data', protocol: 'protocol', thumbprint: 'thumbprint' };
	var location = null;
	
	if (typeof window !== 'undefined') {
	  location = window.location;
	} else {
	  location = {
	    protocol: 'https:'
	  };
	}
	
	// constructor
	// -----------
	
	// defaults for options are handled in options_parser
	function Prefetch(o) {
	  this.url = o.url;
	  this.ttl = o.ttl;
	  this.cache = o.cache;
	  this.prepare = o.prepare;
	  this.transform = o.transform;
	  this.transport = o.transport;
	  this.thumbprint = o.thumbprint;
	
	  this.storage = new PersistentStorage(o.cacheKey);
	}
	
	_.mixin(Prefetch.prototype, {
	
	  _settings: function _settings() {
	    return { url: this.url, type: 'GET', dataType: 'json' };
	  },
	
	  store: function store(data) {
	    if (!this.cache) {
	      return;
	    }
	
	    this.storage.set(keys.data, data, this.ttl);
	    this.storage.set(keys.protocol, location.protocol, this.ttl);
	    this.storage.set(keys.thumbprint, this.thumbprint, this.ttl);
	  },
	
	  fromCache: function fromCache() {
	    var stored = {},
	        isExpired;
	
	    if (!this.cache) {
	      return null;
	    }
	
	    stored.data = this.storage.get(keys.data);
	    stored.protocol = this.storage.get(keys.protocol);
	    stored.thumbprint = this.storage.get(keys.thumbprint);
	
	    // the stored data is considered expired if the thumbprints
	    // don't match or if the protocol it was originally stored under
	    // has changed
	    isExpired = stored.thumbprint !== this.thumbprint || stored.protocol !== location.protocol;
	
	    // TODO: if expired, remove from local storage
	
	    return stored.data && !isExpired ? stored.data : null;
	  },
	
	  fromNetwork: function fromNetwork(cb) {
	    var that = this,
	        settings;
	
	    if (!cb) {
	      return;
	    }
	
	    settings = this.prepare(this._settings());
	
	    // this.transport(settings).fail(onError).done(onResponse);
	    this.transport(settings).then(onResponse, onError);
	
	    function onError() {
	      cb(true);
	    }
	    function onResponse(resp) {
	      cb(null, that.transform(resp));
	    }
	  },
	
	  clear: function clear() {
	    this.storage.clear();
	    return this;
	  }
	});
	
	module.exports = Prefetch;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * typeahead.js
	 * https://github.com/twitter/typeahead.js
	 * Copyright 2013-2014 Twitter, Inc. and other contributors; Licensed MIT
	 */
	
	'use strict';
	
	var _ = __webpack_require__(1);
	var Transport = __webpack_require__(4);
	
	function Remote(o) {
	  this.url = o.url;
	  this.prepare = o.prepare;
	  this.transform = o.transform;
	
	  this.transport = new Transport({
	    cache: o.cache,
	    limiter: o.limiter,
	    transport: o.transport
	  });
	}
	
	_.mixin(Remote.prototype, {
	  // ### private
	
	  _settings: function settings() {
	    return {
	      url: this.url,
	      type: 'GET',
	      dataType: 'json'
	    };
	  },
	
	  get: function get(query, cb) {
	    var that = this,
	        settings;
	
	    if (!cb) {
	      return;
	    }
	
	    query = query || '';
	    settings = this.prepare(query, this._settings());
	
	    return this.transport.get(settings, onResponse);
	
	    function onResponse(err, resp) {
	      err ? cb([]) : cb(that.transform(resp));
	    }
	  },
	
	  cancelLastRequest: function cancelLastRequest() {
	    this.transport.cancel();
	  }
	});
	
	module.exports = Remote;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	
	var CHILDREN = 'c';
	var IDS = 'i';
	
	function SearchIndex(o) {
	  o = o || {};
	
	  if (!o.datumTokenizer || !o.queryTokenizer) {
	    throw new Error('datumTokenizer and queryTokenizer are both required');
	  }
	
	  this.identify = o.identify || _.stringify;
	  this.datumTokenizer = o.datumTokenizer;
	  this.queryTokenizer = o.queryTokenizer;
	
	  this.reset();
	}
	
	_.mixin(SearchIndex.prototype, {
	
	  bootstrap: function bootstrap(o) {
	    this.datums = o.datums;
	    this.trie = o.trie;
	  },
	
	  add: function add(data) {
	    var that = this;
	
	    data = _.isArray(data) ? data : [data];
	
	    _.each(data, function (datum) {
	      var id, tokens;
	
	      that.datums[id = that.identify(datum)] = datum;
	      tokens = normalizeTokens(that.datumTokenizer(datum));
	
	      _.each(tokens, function (token) {
	        var node, chars, ch;
	
	        node = that.trie;
	        chars = token.split('');
	
	        while (ch = chars.shift()) {
	          node = node[CHILDREN][ch] || (node[CHILDREN][ch] = newNode());
	          node[IDS].push(id);
	        }
	      });
	    });
	  },
	
	  get: function get(ids) {
	    var that = this;
	
	    return _.map(ids, function (id) {
	      return that.datums[id];
	    });
	  },
	
	  search: function search(query) {
	    var that = this,
	        tokens,
	        matches;
	
	    tokens = normalizeTokens(this.queryTokenizer(query));
	
	    _.each(tokens, function (token) {
	      var node, chars, ch, ids;
	
	      // previous tokens didn't share any matches
	      if (matches && matches.length === 0) {
	        return false;
	      }
	
	      node = that.trie;
	      chars = token.split('');
	
	      while (node && (ch = chars.shift())) {
	        node = node[CHILDREN][ch];
	      }
	
	      if (node && chars.length === 0) {
	        ids = node[IDS].slice(0);
	        matches = matches ? getIntersection(matches, ids) : ids;
	      }
	
	      // break early if we find out there are no possible matches
	      else {
	          matches = [];
	          return false;
	        }
	    });
	
	    return matches ? _.map(unique(matches), function (id) {
	      return that.datums[id];
	    }) : [];
	  },
	
	  all: function all() {
	    var values = [];
	
	    for (var key in this.datums) {
	      values.push(this.datums[key]);
	    }
	
	    return values;
	  },
	
	  reset: function reset() {
	    this.datums = {};
	    this.trie = newNode();
	  },
	
	  serialize: function serialize() {
	    return { datums: this.datums, trie: this.trie };
	  }
	});
	
	function normalizeTokens(tokens) {
	  // filter out falsy tokens
	  tokens = _.filter(tokens, function (token) {
	    return !!token;
	  });
	
	  // normalize tokens
	  tokens = _.map(tokens, function (token) {
	    return token.toLowerCase();
	  });
	
	  return tokens;
	}
	
	function newNode() {
	  var node = {};
	
	  node[IDS] = [];
	  node[CHILDREN] = {};
	
	  return node;
	}
	
	function unique(array) {
	  var seen = {},
	      uniques = [];
	
	  for (var i = 0, len = array.length; i < len; i++) {
	    if (!seen[array[i]]) {
	      seen[array[i]] = true;
	      uniques.push(array[i]);
	    }
	  }
	
	  return uniques;
	}
	
	function getIntersection(arrayA, arrayB) {
	  var ai = 0,
	      bi = 0,
	      intersection = [];
	
	  arrayA = arrayA.sort();
	  arrayB = arrayB.sort();
	
	  var lenArrayA = arrayA.length,
	      lenArrayB = arrayB.length;
	
	  while (ai < lenArrayA && bi < lenArrayB) {
	    if (arrayA[ai] < arrayB[bi]) {
	      ai++;
	    } else if (arrayA[ai] > arrayB[bi]) {
	      bi++;
	    } else {
	      intersection.push(arrayA[ai]);
	      ai++;
	      bi++;
	    }
	  }
	
	  return intersection;
	}
	
	module.exports = SearchIndex;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * typeahead.js
	 * https://github.com/twitter/typeahead.js
	 * Copyright 2013-2014 Twitter, Inc. and other contributors; Licensed MIT
	 */
	
	'use strict';
	
	var _ = __webpack_require__(1);
	
	function whitespace(str) {
	  str = _.toStr(str);
	  return str ? str.split(/\s+/) : [];
	}
	
	function nonword(str) {
	  str = _.toStr(str);
	  return str ? str.split(/\W+/) : [];
	}
	
	function getObjTokenizer(tokenizer) {
	  return function setKey(keys) {
	    keys = _.isArray(keys) ? keys : [].slice.call(arguments, 0);
	
	    return function tokenize(o) {
	      var tokens = [];
	
	      _.each(keys, function (k) {
	        tokens = tokens.concat(tokenizer(_.toStr(o[k])));
	      });
	
	      return tokens;
	    };
	  };
	}
	
	module.exports = {
	  nonword: nonword,
	  whitespace: whitespace,
	  obj: {
	    nonword: getObjTokenizer(nonword),
	    whitespace: getObjTokenizer(whitespace)
	  }
	};

/***/ },
/* 24 */
/***/ function(module, exports) {

	/*
	 * typeahead.js
	 * https://github.com/twitter/typeahead.js
	 * Copyright 2013-2014 Twitter, Inc. and other contributors; Licensed MIT
	 */
	
	'use strict';
	
	module.exports = '1.0.0';

/***/ },
/* 25 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** bloodhound.min.js
 **/